import tmhRequest from '@/config/tmhRequest'

export default {
    searchMyCouponReportCount: function (data) {
        return tmhRequest({
            url: '/report/ispa/mycouponreport/searchmycouponreportcount',
            method: 'post',
            data: data,
        })
    },
    searchMyCouponReportByPage: function (data) {
        return tmhRequest({
            url: '/report/ispa/mycouponreport/searchmycouponreportbypage',
            method: 'post',
            data: data,
        })
    },
    exportMyCouponReport: function (data) {
        return tmhRequest({
            url: '/report/ispa/mycouponreport/exportmycouponreport',
            method: 'post',
            responseType: 'blob',
            data: data,
        })
    },
}


// WEBPACK FOOTER //
// ./src/api/ispa/report/mycouponreport.js